// Motion tokens. Durations in seconds for Framer Motion; ms values mirrored for CSS.
// Reduced motion: movement becomes a 120 ms opacity fade (see `fadeOnly`).
import type { Transition, Variants } from 'framer-motion';

export const duration = { fast: 0.12, base: 0.22, slow: 0.4, reveal: 0.9 } as const;
export const ms = { fast: 120, base: 220, slow: 400, reveal: 900 } as const;
export const easeOut = [0.2, 0.7, 0.2, 1] as const;
export const spring: Transition = { type: 'spring', stiffness: 400, damping: 36 };
export const stagger = { list: 0.03, map: 0.04 } as const;

export const base: Transition = { duration: duration.base, ease: easeOut };
export const fadeOnly: Transition = { duration: duration.fast, ease: 'linear' };

// Shared-axis page/queue slide (±24 px, 220 ms).
export const sharedAxis = (reduced: boolean | null): Variants =>
  reduced
    ? { initial: { opacity: 0 }, animate: { opacity: 1, transition: fadeOnly }, exit: { opacity: 0, transition: fadeOnly } }
    : {
        initial: { opacity: 0, y: 12 },
        animate: { opacity: 1, y: 0, transition: base },
        exit: { opacity: 0, y: -12, transition: { duration: duration.fast, ease: easeOut } },
      };
